import { CustomerSchema } from '@sophocles/features/customers/schema';
import { schema } from 'normalizr';

const SiteGroupWeatherConfigurationSchema = new schema.Entity('weatherConfigurations', {});

const SiteGroupSchema = new schema.Entity('siteGroups', {
  customer: CustomerSchema,
  weather_configuration: SiteGroupWeatherConfigurationSchema,
});

const SiteGroupCurfewSchema = new schema.Entity('curfews', {});

export { SiteGroupSchema, SiteGroupWeatherConfigurationSchema, SiteGroupCurfewSchema };
